import React from 'react'

const PulseBar: React.FC<{ className: string }> = ({ className }) => (
  <div className={`animate-pulse rounded-md bg-zinc-200/90 ${className}`} />
)

/** Right definition panel only — mirrors SegmentDefinitionPanel + conditions area */
const SegmentDefinitionPanelSkeleton: React.FC = () => {
  return (
    <div className='flex h-full flex-col'>
      <div className='flex flex-1 flex-col overflow-y-auto'>
        <div className='space-y-3 px-8 pb-5'>
          <PulseBar className='h-5 w-16' />
          <PulseBar className='h-9 w-full' />
          <PulseBar className='h-4 w-full max-w-md' />
        </div>
        {/* Same row as SegmentDefinitionPanel “Users” rule: [dotted w-6][label][flex-1 dotted][icon xs][dotted w-6] */}
        <div className='mb-4 flex flex-row items-center gap-2 px-8'>
          <div className='w-6 shrink-0 border-t-2 border-dotted border-zinc-950/10' />
          <PulseBar className='h-4 w-14 shrink-0' />
          <div className='min-w-0 flex-1 border-t-2 border-dotted border-zinc-950/10' />
          <PulseBar className='h-4 w-4 shrink-0 rounded-md' />
          <div className='w-6 shrink-0 border-t-2 border-dotted border-zinc-950/10' />
        </div>
        <div className='flex flex-col gap-3 px-8'>
          <PulseBar className='h-4 w-40' />
          <PulseBar className='h-4 w-full max-w-xs' />
          <PulseBar className='h-4 w-full max-w-sm' />
          <div className='flex gap-2 pt-1'>
            <PulseBar className='h-5 w-24' />
            <PulseBar className='h-5 w-20' />
          </div>
          <PulseBar className='mt-2 h-5 w-48' />
        </div>
      </div>
    </div>
  )
}

export default SegmentDefinitionPanelSkeleton
